import { useMemo, useContext } from 'react';
import ReactEcharts from 'echarts-for-react';
import Head from '@/containers/chart_box/Head';
import Body from '@/containers/chart_box/Body';
import { ThemeContext } from 'styled-components';
import { fmtThousand } from '@/utils/comUtil';
import { BrandContext } from '@/contexts/ContextProviders';
import { sinTimeDimensionSinIndexMulValue } from '@/utils/reportResponseUtil';

// tooltip / 轴标签回调提升到模块级，保证数据不变时 option 内容可被深度比较命中，
// 避免 ReactEcharts 因为回调引用变化而重复 setOption
const tooltipPosition = (pt) => {
  return [pt[0], '10%'];
};

const tooltipFormatter = (p) => {
  const tip = [];
  if (p && Array.isArray(p)) {
    p.forEach((i) => {
      if (i.seriesType === 'bar') {
        tip.push(`${i?.seriesName}:${fmtThousand(i?.value)}`);
      } else {
        tip.push(`${i?.seriesName}:${(i?.value * 100).toFixed(2)}%`);
      }
    });
  }
  let node = '日注册趋势<br/>';
  tip.forEach((i, index) => {
    if (index === 1) {
      node += '<br/>' + i;
    } else {
      node += i;
    }
  });
  return node;
};

const rateAxisFormatter = (p) => {
  return `${p * 100}%`;
};

const LineDistribution = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const { charts } = themeContext[brandContext];
  const { chartsFontSize, fontFamily } = themeContext.comm;
  const { loading10, data = [], title } = props;

  // 渲染阶段直接计算 option，图表挂载时拿到的就是完整配置，
  // 避免先挂载空 option 再由 effect 补一次而绘制两遍
  const option = useMemo(() => {
    if (!data || data.length === 0) {
      return null;
    }
    const sortedData = [...data].sort((a, b) => {
      const aValueType = a.values?.find(
        (item) => item.valueType === 'SORT',
      )?.value;
      const bValueType = b.values?.find(
        (item) => item.valueType === 'SORT',
      )?.value;

      return Number(aValueType) - Number(bValueType);
    });
    const CONVERSION_RATES = sortedData.filter((item) => {
      return item.index === 'CONVERSION_RATES';
    });
    const NUMBER = sortedData.filter((item) => {
      return item.index === 'NUMBER';
    });
    const XData = CONVERSION_RATES.map((item) => {
      return [item.values[0].value, item.values[1].value];
    });
    // eslint-disable-next-line camelcase
    let CONVERSION_RATES_Data = [];
    // eslint-disable-next-line camelcase
    let NUMBER_Data = [];
    sinTimeDimensionSinIndexMulValue(CONVERSION_RATES || []).forEach((e) => {
      CONVERSION_RATES_Data.push(e.VALUE);
    });

    sinTimeDimensionSinIndexMulValue(NUMBER || []).forEach((e) => {
      NUMBER_Data.push(e.VALUE);
    });

    return {
      legend: {
        left: 'right',
        itemHeight: 5,
        itemWidth: 15,
        zlevel: 1,
      },
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      tooltip: {
        trigger: 'axis',
        // axisPointer: {
        //   type: 'cross',
        //   crossStyle: {
        //     color: '#999',
        //   },
        // },
        position: tooltipPosition,
        textStyle: {
          fontSize: chartsFontSize.s03,
        },
        formatter: tooltipFormatter,
      },
      grid: {
        left: 5,
        right: 1,
        containLabel: true,
      },
      barCategoryGap: '50%',
      xAxis: {
        data: XData.map(function (item) {
          return item[0];
        }),
        type: 'category',
        axisLabel: {
          textStyle: {
            color: '#333',
          },
        },
      },
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#333',
            },
          },
        },
        {
          type: 'value',
          min: 0,
          max: 1,
          splitLine: {
            show: false,
          },
          axisLabel: {
            formatter: rateAxisFormatter,
            textStyle: {
              color: '#333',
            },
          },
        },
      ],
      dataZoom: [
        {
          show: true,
          realtime: true,
          height: 15, //这里可以设置dataZoom的尺寸
          bottom: '10%',
        },
        {
          type: 'inside',
        },
      ],
      color: charts.barColorList,
      series: [
        {
          name: '每日新注册人数',
          type: 'bar',
          data: NUMBER_Data,
          itemStyle: {
            color: '#1976D2',
          },
        },
        {
          name: '注册转化率',
          type: 'line',
          showSymbol: false,
          yAxisIndex: 1,
          lineStyle: {
            color: '#FA6400',
            width: 1,
          },
          itemStyle: {
            color: '#FA6400',
            width: 1,
          },
          data: CONVERSION_RATES_Data,
        },
      ],
    };
  }, [charts.barColorList, chartsFontSize.s03, data, fontFamily]);

  return (
    <>
      <Head boxId={title}></Head>
      <Body bizData={data} loading={loading10}>
        {option && (
          <ReactEcharts
            style={{ width: '100%', height: '100%' }}
            option={option}
            notMerge={true}
            lazyUpdate={true}
          />
        )}
      </Body>
    </>
  );
};
export default LineDistribution;
